import { useJsApiLoader } from '@react-google-maps/api';
import { GOOGLE_MAPS_LIBRARIES, GOOGLE_MAPS_SCRIPT_ID } from './trip-map-utils';

/**
 * Loads the Google Maps JavaScript API with the configuration every telematics
 * map shares. Multiple callers reuse the same script tag.
 */
export const useGoogleMapsApi = () =>
	useJsApiLoader({
		id: GOOGLE_MAPS_SCRIPT_ID,
		googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? '',
		libraries: GOOGLE_MAPS_LIBRARIES,
	});

export default useGoogleMapsApi;
